import * as yup from 'yup';
import creditCardType from 'credit-card-type';


let cardTypeInfo = {};

const defineCardTypeInfo = (val) => {
  const [cardInfo] = creditCardType(val);
  cardTypeInfo = cardInfo;
};

export const validationSchema = yup.object({
  storeInformation: yup.object({
    firstName: yup
      .string()
      .required('Field is required'),
    lastName: yup
      .string()
      .required('Field is required'),
    storeName: yup
      .string()
      .required('Field is required'),
    streetAddress1: yup
      .string()
      .required('Field is required'),
    city: yup
      .string()
      .required('Field is required'),
    state: yup
      .string()
      .required('Field is required'),
    zipCode: yup
      .string()
      .matches(/(^\d{5}$)/, 'Invalid zip code')
      .required('Field is required'),
    phone: yup
      .string()
      .matches(/^(\()?\d{3}(\))?(-|\s)?\d{3}(-|\s)\d{4}$/, 'Phone number must be formatted as (###)-###-####')
      .required('Field is required')
  }),
  billingInformation: yup.object({
    ccNumber: yup
      .string()
      .test('ccNumber', 'Unknown payment card type, try to use another card', (val) => {
        if (!val) {
          return true;
        }

        defineCardTypeInfo(val);

        return Boolean(cardTypeInfo);
      })
      .test('ccNumber', 'Credit card number not valid', (val) => {
        if (!val || Boolean(!cardTypeInfo)) {
          return true;
        }

        defineCardTypeInfo(val);

        //add valid length 13, acc. to https://www.paypalobjects.com/en_AU/vhelp/paypalmanager_help/credit_card_numbers.htm
        if (cardTypeInfo?.type === 'visa') {
          cardTypeInfo.lengths = [...cardTypeInfo.lengths, 13];
        }

        return cardTypeInfo?.lengths?.includes(val.length);
      })
      .required('Field is required'),
    firstName: yup
      .string()
      .required('Field is required'),
    lastName: yup
      .string()
      .required('Field is required'),
    streetAddress1: yup
      .string()
      .required('Field is required'),
    city: yup
      .string()
      .required('Field is required'),
    state: yup
      .string()
      .required('Field is required'),
    zipCode: yup
      .string()
      .matches(/(^\d{5}$)/, 'Invalid zip code')
      .required('Field is required'),
    phone: yup
      .string()
      .matches(/^(\()?\d{3}(\))?(-|\s)?\d{3}(-|\s)\d{4}$/, 'Phone number must be formatted as (###)-###-####')
      .required('Field is required'),
    ccCVV: yup
      .string()
      .matches(/(^\d{3,4}$)/, 'Invalid CVV')
      .required('Field is required'),
    expiry: yup
      .string()
      .typeError('Not a valid expiration date. Example: MM/YY')
      .max(5, 'Not a valid expiration date. Example: MM/YY')
      .matches(
        /([0-9]{2})\/([0-9]{2})/,
        'Not a valid expiration date. Example: MM/YY'
      )
      .required('Field is required')
      .test(
        'test-credit-card-expiration-date',
        'Expiration Date has passed',
        (expirationDate) => {
          if (!expirationDate) {
            return false;
          }

          const today = new Date();
          const monthToday = today.getMonth() + 1;
          const yearToday = today
            .getFullYear()
            .toString()
            .substr(-2);

          const [expMonth, expYear] = expirationDate.split('/');

          if (Number(expYear) < Number(yearToday)) {
            return false;
          } else if (
            Number(expMonth) < monthToday &&
              Number(expYear) <= Number(yearToday)
          ) {
            return false;
          }

          return true;
        }
      )
      .test(
        'test-credit-card-expiration-date',
        'Invalid Expiration Month',
        (expirationDate) => {
          if (!expirationDate) {
            return false;
          }

          const [expMonth] = expirationDate.split('/');

          if (Number(expMonth) > 12) {
            return false;
          }

          return true;
        }
      )
  })
});
